import "core-js/modules/es.array.push.js";
import { audioContextObj } from '@/assets/js/audioContext';
import { mapState } from 'vuex';
export default {
  props: {
    muteAudio: {
      type: Boolean,
      default: true
    },
    peerId: {
      type: String,
      default: ''
    },
    platForm: {
      type: String,
      default: ''
    },
    partyCode: {
      type: String,
      default: ''
    },
    anyWhereSetObj: {
      type: Object,
      default: function () {
        return {};
      }
    },
    degreeHost: [String, Number],
    devicesInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    rtc: {
      type: Object,
      default: () => {
        return {};
      }
    },
    singChannel: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      initPosition: [],
      activeType: '',
      activeBtn: '',
      loading: {
        first: false,
        second: false
      },
      activePosition: '',
      userManualSetPositions: [],
      userInput: false,
      clickGimbal: false,
      // 存储所有预设位置
      presetPositions: [{
        name: 'Position_1',
        leftRight: 0,
        upDown: 0,
        zoom: 1,
        inputZoom: 1
      }, {
        name: 'Position_2',
        leftRight: 0,
        upDown: 0,
        zoom: 1,
        inputZoom: 1
      }],
      isEditing: false,
      editedName: '',
      // 当前角度
      current: {
        leftRight: 0,
        upDown: 0,
        zoom: 1
      },
      // 预设角度
      preset: {
        leftRight: 0,
        upDown: 0,
        zoom: 1
      },
      displayPrePosition: false,
      manualPositionDisabled: true,
      changeSpeakerSwitch: false,
      operationStatus: null,
      operationMessage: '',
      operationTimer: null,
      isSupportGimbal: '',
      isTopPressed: false,
      isBottomPressed: false,
      isLeftPressed: false,
      isRightPressed: false,
      isCenterPressed: false,
      direction: -1,
      // 用于存储方向（0:上, 1:下, 2:左, 3:右）
      longPressGimbalEvent: 0,
      // 0:结束，1:开始
      pressTimer: null,
      // 用于记录长按计时器
      isLongPress: false,
      // 新增一个标志以区分长按与单击
      location: '',
      debounceTimer: null,
      // 用于存储防抖定时器
      positionTimer: null,
      lastParams: null,
      defaultView: '',
      defaultViewOptions: [{
        value: '0',
        label: 'fullScreen'
      }, {
        value: '1',
        label: 'partylineView'
      }],
      params: {},
      locked: '',
      speakerStatus: 1,
      autoFocus: '',
      autoExposure: '',
      cameraPosition: '',
      micPosition: '',
      cameraOptions: [],
      micOptions: [],
      resolutionOptions: [],
      resolutionList: [],
      fpsList: [],
      resolution: '',
      fpsOptions: [],
      whiteBalanceAuto: '',
      whiteBalanceType: '',
      whiteBalanceOptions: [],
      fps: '',
      temperature: 0,
      zoom: 0,
      inputZoom: '',
      speakerVolume: 100,
      inputVolume: 100,
      inputTemperature: '',
      tints: 0,
      inputTints: '',
      focus: 0,
      exposure: 0,
      inputFocus: '',
      inputExposure: ''
    };
  },
  watch: {
    // computedMicOptions (newOptions) {
    //   if (newOptions.length > 0) {
    //   // 检查 micPosition 是否存在，不存在则设为默认值
    //     if (!newOptions.find(item => item.value === this.micPosition)) {
    //       this.micPosition = newOptions[0]?.value || '';
    //     }
    //   }
    // },
    'anyWhereSetObj.isSupportGimbal': {
      handler(newValue) {
        // position 预设
        if (newValue == '1') {
          this.getPrePositionDegree();
        }
      },
      immediate: true
    },
    'anyWhereSetObj.gimbalAngleValue': {
      handler(newValue) {
        // 获取当前位置角度映射
        // vertical ：0:top, 1:bottom
        // horizontal：2:left, 3:right
        if (newValue) {
          this.mapCurGimbalAngleToDegrees(JSON.parse(newValue));
          this.$set(this.loading, this.activeBtn, false);
        }
      },
      immediate: true
    },
    anyWhereSetObj: {
      handler(newValue) {
        // 根据最新的 anyWhereSetObj 来更新
        this.initializeSettingsBasedOn(newValue);
      },
      deep: true,
      immediate: true
    },
    singChannel: {
      handler(newValue) {
        if (newValue && newValue.audioTrack) {
          const media = new MediaStream();
          media.addTrack(newValue.audioTrack._mediaStreamTrack);
          audioContextObj.audioTrack(media, 'volume');
          setTimeout(() => {
            audioContextObj.resumeAudio('volume');
          }, 1000);
        }
      },
      immediate: true
    }
  },
  async mounted() {
    // 位置
    this.getLocation();
    // 上报behavior 获取
    this.initializeSettingsBasedOn(this.anyWhereSetObj);
    // speakerVolume
    this.inputVolume = this.speakerVolume = this.anyWhereSetObj.speakerVolume && Number(this.anyWhereSetObj.speakerVolume);
  },
  computed: {
    ...mapState({
      State: state => state,
      Config: state => state.config
    }),
    // 设备类型 anyWhere或者partylineAPP
    deviceType() {
      return this.singChannel.id && this.State.deviceTypeMap[this.singChannel.id];
    },
    // 有的设备不支持预设角度会上报空范围
    isSupportPreSetBtn() {
      if (Number(JSON.parse(this.anyWhereSetObj.gimbalAngleRange)[0].max) == 0 && Number(JSON.parse(this.anyWhereSetObj.gimbalAngleRange)[0].min) == 0) {
        return false;
      } else {
        return true;
      }
    },
    isMatchPositionOne() {
      return this.activePosition === 'first' || this.checkPositionMatch(0);
    },
    isMatchPositionTwo() {
      return this.activePosition === 'second' || this.checkPositionMatch(1);
    },
    computedMicOptions() {
      return this.micOptions.map(device => ({
        label: device.deviceName,
        value: device.deviceID,
        disabled: false
      }));
    },
    // anyWhere所有限制规则(anyWhere支持的最低分辨率是640 x 480)
    // 1.当用户选择 2160p/480p 或者 fps:50/60 时，禁止 双镜操作
    // 2.当用户打开 双镜 时，禁止选择 分辨率：2160p/480p 和  帧率:50/60
    // 3.当选择分辨率是1080i，fps不是50或60，则禁用该fps选项

    // 1.用户选择 2160p/480p或者 fps:50/60 时，禁止 双镜操作
    computedCameraOptions() {
      return this.cameraOptions.map(option => {
        const isDisabled = (this.resolution === '2160p' || this.resolution === '480p' || this.fps === '50' || this.fps === '60') && (option.value === '4' || option.value === '3') && !this.resolution.includes('i');
        return {
          ...option,
          disabled: isDisabled
        };
      });
    },
    computedMacCameraOptions() {
      return this.cameraOptions.map(option => {
        const isDisabled = (this.resolution === '2160p' || this.resolution === '480p' || this.fps === '50' || this.fps === '60') && (option.value === '4' || option.value === '3') && !this.resolution.includes('i');
        return {
          label: option.deviceName,
          value: option.deviceID,
          disabled: isDisabled
        };
      });
    },
    // 2.1用户选择双镜操作，禁止 选择 分辨率：2160p/480p
    computedResolutionOptions() {
      return this.resolutionOptions.map(option => {
        const isDisabled = (option.label === '2160p' || option.label === '480p') && (this.cameraPosition === '4' || this.cameraPosition === '3');
        return {
          ...option,
          disabled: isDisabled
        };
      });
    },
    // 2.2用户选择双镜操作禁止 选择帧率:50/60，
    // 3.分辨率是1080i，fps不是50或60，则禁用
    computedFpsOptions() {
      return this.fpsOptions.map(option => {
        // 如果选项是50或60帧率
        const isOption50or60 = option.label === '50' || option.label === '60';
        // 如果是双镜头模式
        const isDualCameraPosition = this.cameraPosition === '4' || this.cameraPosition === '3';
        // 如果是1080i分辨率，仅允许50和60帧率的选项
        // 如果是双镜头模式，并且选项是50或60帧率，则禁用
        // 如果不是1080i并存在任何其它条件，则按原有逻辑启用或禁用选项
        let isDisabled;
        if (this.resolution === '1080i') {
          // 如果分辨率是1080i，但选项不是50或60，则禁用
          isDisabled = !isOption50or60;
        } else {
          // 如果不是1080i分辨率
          // 如果是双镜头且选项是50或60，则禁用
          isDisabled = isDualCameraPosition && isOption50or60;
        }
        return {
          ...option,
          disabled: isDisabled
        };
      });
    }
  },
  methods: {
    // 兼容MAC联动更新fps列表
    handleResolutionChange(newResolution) {
      const parsedResList = JSON.parse(this.anyWhereSetObj.resolutionList);
      const matched = parsedResList.find(item => item.resolution === newResolution);
      // 更新帧率列表
      this.fpsList = matched ? matched.fps.map(f => ({
        label: f
      })) : [];
    },
    // 更改input直接看到角度变化
    // 先save再 apply
    changePresetPosition(type, value) {
      this.userInput = true;
      const index = this.activeType === 'first' ? 0 : 1;
      const ranges = JSON.parse(this.anyWhereSetObj.gimbalAngleRange);

      // 获取限制范围
      let max, min;
      if (type === 'upDown') {
        max = Number(ranges[0].max); // 上方向最大值
        min = -Number(ranges[1].max); // 下方向最大值（取负数）
      } else {
        max = Number(ranges[3].max); // 右方向最大值
        min = -Number(ranges[2].max); // 左方向最大值
      }

      // 边界检查
      let adjustedValue = Math.max(Math.min(value, max), min);

      // 保留两位小数
      adjustedValue = Number(adjustedValue.toFixed(2));

      // 更新值
      this.presetPositions[index][type] = adjustedValue;
      // 记录用户手动输入的值，为了后面ws有误差不要覆盖用户的输入
      this.userManualSetPositions = this.presetPositions;
      clearTimeout(this.positionTimer);
      // 设置新的防抖定时器
      this.positionTimer = setTimeout(() => {
        // 立即保存应用
        this.saveDegree(true);
      }, 500);
    },
    async applyPosition(type, immediatExcute) {
      this.activeBtn = type;
      // 如果另一个按钮正在loading，直接返回
      const anotherType = type === 'first' ? 'second' : 'first';
      if (this.loading[anotherType]) return;
      // 不能重复应用已经在使用的预设btn
      if (type == 'first' && this.isMatchPositionOne && !this.displayPrePosition) {
        return;
      }
      if (type == 'second' && this.isMatchPositionTwo && !this.displayPrePosition) {
        return;
      }
      try {
        // 立即更新loading状态
        this.$set(this.loading, type, true);
        const index = type === 'first' ? 0 : 1;
        const preset = this.presetPositions[index];
        // 这组数据不在这个范围内this.anyWhereSetObj.gimbalAngleRange 需要return
        // 云台角度范围验证
        if (this.anyWhereSetObj.gimbalAngleRange) {
          const ranges = JSON.parse(this.anyWhereSetObj.gimbalAngleRange);

          // 上下方向范围
          const verticalMax = Number(ranges[0].max); // 上方向最大值
          const verticalMin = -Number(ranges[1].max); // 下方向最小值

          // 左右方向范围
          const horizontalMax = Number(ranges[3].max); // 右方向最大值
          const horizontalMin = -Number(ranges[2].max); // 左方向最小值

          // 检查上下方向
          if (preset.upDown > verticalMax || preset.upDown < verticalMin) {
            this.$message({
              type: 'error',
              message: this.$t('anywhereSetting.prePosition')
            });
            return;
          }
          // 检查左右方向
          if (preset.leftRight > horizontalMax || preset.leftRight < horizontalMin) {
            this.$message({
              type: 'error',
              message: this.$t('anywhereSetting.prePosition')
            });
            return;
          }
        }
        const params = {
          name: preset.name,
          peerId: this.peerId,
          partyCode: this.partyCode
        };
        const res = await this.axios.post('/partyline-backend/anywhere/preset/apply', params);
        if (res.data.errorCode == '0x0') {
          this.current.upDown = preset.upDown;
          this.current.leftRight = preset.leftRight;
          this.activePosition = type;
          if (immediatExcute) {
            this.$set(this.loading, type, false);
          }
          this.$message({
            type: 'success',
            message: this.$t('commonFunction.operateSuccessful')
          });
        } else {
          this.$set(this.loading, type, false);
          this.$message({
            type: 'error',
            message: this.$t('commonFunction.operateFailed')
          });
        }
      } catch (error) {
        this.loading[type] = false;
        console.error(error);
      }
    },
    startEditing() {
      this.isEditing = true;
      this.editedName = this.presetPositions[this.activeType === 'first' ? 0 : 1].name;
      this.$nextTick(() => {
        this.$refs.nameInput.focus();
        this.$refs.nameInput.select();
      });
    },
    saveEdit() {
      this.isEditing = false;
      if (this.editedName !== this.presetPositions[this.activeType === 'first' ? 0 : 1].name) {
        // 先删除原来的
        try {
          const params = {
            name: this.presetPositions[this.activeType === 'first' ? 0 : 1].name,
            peerId: this.peerId
          };
          this.axios.delete('/partyline-backend/anywhere/preset', {
            data: params
          }).then(res => {
            if (res.data.errorCode === '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('copy.rename')
              });
            }
          });
        } catch (error) {
          console.error(error);
        }
        this.presetPositions[this.activeType === 'first' ? 0 : 1].name = this.editedName;
      }
    },
    mapCurGimbalAngleToDegrees(gimbalAngleValue) {
      const {
        vertical,
        horizontal
      } = gimbalAngleValue;
      switch (vertical.direction) {
        case 0:
          // Top
          this.current.upDown = Math.round(vertical.angle);
          break;
        case 1:
          // Bottom
          this.current.upDown = -Math.round(vertical.angle);
          break;
        default:
          this.current.upDown = 0;
      }
      switch (horizontal.direction) {
        case 2:
          // Left
          this.current.leftRight = -Math.round(horizontal.angle);
          break;
        case 3:
          // Right
          this.current.leftRight = Math.round(horizontal.angle);
          break;
        default:
          this.current.leftRight = 0;
      }
      // 操作圆盘或用户输入input时，更新数组presetPositions中度数的值
      if (this.presetPositions.length != 0 && this.activeType) {
        const index = this.activeType === 'first' ? 0 : 1;
        const preset = this.presetPositions[index];
        const userset = this.userManualSetPositions[index];
        // 输入值
        if (this.userInput) {
          // 仅在差值超过误差时更新预设值
          // 安卓使用5度，ios使用2度
          const threshold = this.platForm == '11' ? 5 : 2;
          if (Math.abs(userset.upDown - this.current.upDown) > threshold) {
            preset.upDown = this.current.upDown;
          }
          if (Math.abs(userset.leftRight - this.current.leftRight) > threshold) {
            preset.leftRight = this.current.leftRight;
          }
          this.userInput = false;
        }
        // 圆盘
        if (this.clickGimbal) {
          preset.upDown = this.current.upDown;
          preset.leftRight = this.current.leftRight;
          this.clickGimbal = false;
        }
      }
    },
    // 获取预设位置数据
    async getPrePositionDegree() {
      if (!this.peerId) return;
      try {
        const res = await this.axios.get(`/partyline-backend/anywhere/preset/${this.peerId}`);
        if (res.data.errorCode === '0x0') {
          var _res$data$result;
          // 处理原始数据
          const rawPositions = (_res$data$result = res.data.result) !== null && _res$data$result !== void 0 && _res$data$result.length ? res.data.result.slice(0, 2) : [];
          this.initPosition = rawPositions;
          // 映射有效数据
          const mapped = rawPositions.map((item, index) => {
            try {
              var _angle$vertical, _angle$vertical2, _angle$vertical3, _angle$horizontal, _angle$horizontal2, _angle$horizontal3;
              const setting = JSON.parse(item.value || '{}');
              const angle = JSON.parse(setting.specifyGimbalAngle || '{}');
              const zoom = JSON.parse(setting.zoom || '{"zoom":1}').zoom;
              return {
                name: item.key || `Position_${index + 1}`,
                upDown: ((_angle$vertical = angle.vertical) === null || _angle$vertical === void 0 ? void 0 : _angle$vertical.direction) === 0 ? ((_angle$vertical2 = angle.vertical) === null || _angle$vertical2 === void 0 ? void 0 : _angle$vertical2.angle) || 0 : -(((_angle$vertical3 = angle.vertical) === null || _angle$vertical3 === void 0 ? void 0 : _angle$vertical3.angle) || 0),
                leftRight: ((_angle$horizontal = angle.horizontal) === null || _angle$horizontal === void 0 ? void 0 : _angle$horizontal.direction) === 3 ? ((_angle$horizontal2 = angle.horizontal) === null || _angle$horizontal2 === void 0 ? void 0 : _angle$horizontal2.angle) || 0 : -(((_angle$horizontal3 = angle.horizontal) === null || _angle$horizontal3 === void 0 ? void 0 : _angle$horizontal3.angle) || 0),
                zoom: Number(zoom) || 1,
                inputZoom: Number(zoom) || 1
              };
            } catch (e) {
              return this.generateDefaultPosition(index);
            }
          });

          // 补全缺失位置
          for (let i = mapped.length; i < 2; i++) {
            mapped.push(this.generateDefaultPosition(i));
          }
          this.presetPositions = mapped;
        }
      } catch (error) {
        console.error('获取预设位置失败:', error);
        this.presetPositions = [0, 1].map(i => this.generateDefaultPosition(i));
      }
    },
    // 生成默认位置对象
    generateDefaultPosition(index) {
      return {
        name: `Position_${index + 1}`,
        upDown: 0,
        leftRight: 0,
        zoom: 1,
        inputZoom: 1
      };
    },
    checkPositionMatch(index) {
      this.activePosition = '';
      if (!this.presetPositions[index]) return false;
      // 误差安卓使用5度，ios使用2度
      const threshold = this.platForm == '11' ? 5 : 2;
      const preset = this.presetPositions[index];
      return Math.abs(this.current.upDown - preset.upDown) < threshold && Math.abs(this.current.leftRight - preset.leftRight) < threshold && Math.abs(this.zoom - preset.zoom) < 0.01 && this.initPosition[index];
    },
    constructGimbalAngle(upDown, leftRight) {
      const vertical = {
        direction: 0,
        angle: Math.abs(upDown)
      };
      if (upDown < 0) vertical.direction = 1;
      const horizontal = {
        direction: 3,
        angle: Math.abs(leftRight)
      };
      if (leftRight < 0) horizontal.direction = 2;
      return {
        vertical,
        horizontal
      };
    },
    async saveDegree(immediatExcute, isZoom) {
      try {
        const specifyGimbalAngle = this.constructGimbalAngle(this.presetPositions[this.activeType === 'first' ? 0 : 1].upDown, this.presetPositions[this.activeType === 'first' ? 0 : 1].leftRight);
        const params = {
          name: this.presetPositions[this.activeType === 'first' ? 0 : 1].name,
          peerId: this.peerId,
          setting: {
            specifyGimbalAngle: JSON.stringify(specifyGimbalAngle),
            zoom: JSON.stringify({
              zoom: Number(this.presetPositions[this.activeType === 'first' ? 0 : 1].zoom)
            })
          }
        };
        await this.axios.post('/partyline-backend/anywhere/preset', params).then(async res => {
          if (res.data.errorCode == '0x0') {
            // 不是zoom保存后立即apply，因为zoom保存的时候已经apply
            if (!isZoom) {
              this.applyPosition(this.activeType, true);
            }
            if (!immediatExcute) {
              this.displayPrePosition = false;
              this.activeType = '';
              // 保存之后更新预设位置数据
              await this.getPrePositionDegree();
            }
          } else {
            this.$message({
              type: 'error',
              message: this.$t('commonFunction.operateFailed')
            });
          }
        });
      } catch (error) {
        console.error(error);
      }
    },
    async openPosition(type) {
      // 打开主面板获取预设位置数据
      await this.getPrePositionDegree();
      this.activeType = type;
      this.displayPrePosition = true;
    },
    // 显示标题部分操作提示
    showOperationPrompt(status) {
      if (this.operationTimer) {
        clearTimeout(this.operationTimer);
      }
      this.operationStatus = status;
      this.operationMessage = status === 'success' ? this.$t('commonFunction.operateSuccessful') : this.$t('commonFunction.operateFailed');
      // 设置一个定时器在2秒后隐藏提示
      this.operationTimer = setTimeout(() => {
        this.operationStatus = null;
        this.operationMessage = '';
        this.operationTimer = null;
      }, 2000);
    },
    isDisabled(key) {
      return this.anyWhereSetObj[key] === null;
    },
    getLocation() {
      this.axios.post(`${this.Config.urlInfo.geoServiceUrl}/Out/getGpsInfoByMultiIpOrPeerIdServlet?partyCode=${this.partyCode}`, {
        peerId: this.peerId,
        whiteListKey: 'tvu_geo_white_list_'
      }).then(res => {
        if (!res) return;
        if (res.data.code === '80A01020') {
          var _res$data$data$;
          const fullAddress = (_res$data$data$ = res.data.data[0]) === null || _res$data$data$ === void 0 ? void 0 : _res$data$data$.address;
          this.location = fullAddress;
          // if (fullAddress) {
          //   const parts = fullAddress.split(',')
          //   this.location = `${parts[parts.length - 2]?.trim()}, ${parts[parts.length - 3]?.trim()}`
          // }
        }
      });
    },

    initializeSettingsBasedOn(anyWhereSetObj) {
      this.locked = anyWhereSetObj.lock && anyWhereSetObj.lock || this.locked;
      if (!this.changeSpeakerSwitch) {
        this.speakerStatus = anyWhereSetObj.speakerStatus && anyWhereSetObj.speakerStatus == '1' ? 1 : 0;
      }
      // 只有音量是0并且btn关闭才去读后台发的值
      if (this.inputVolume == 0 && this.speakerStatus == 1) {
        this.inputVolume = this.speakerVolume = anyWhereSetObj.speakerVolume && Number(anyWhereSetObj.speakerVolume);
      } else if (this.speakerStatus == 0) {
        this.inputVolume = this.speakerVolume = 0;
      }
      // 初始化曝光
      this.autoExposure = anyWhereSetObj.autoExposure && anyWhereSetObj.autoExposure || this.autoExposure;
      this.inputExposure = this.exposure = anyWhereSetObj.exposure !== undefined && anyWhereSetObj.exposure !== null ? Number(anyWhereSetObj.exposure) : this.inputExposure || this.exposure;
      // 初始化自动聚焦
      this.autoFocus = anyWhereSetObj.autoFocus && anyWhereSetObj.autoFocus || this.autoFocus;
      this.inputFocus = this.focus = anyWhereSetObj.focusDistance !== undefined && anyWhereSetObj.focusDistance !== null ? Number(anyWhereSetObj.focusDistance) : this.inputFocus || this.focus;
      // 分辨率/码率
      this.fps = anyWhereSetObj.fps && anyWhereSetObj.fps || this.fps;
      this.resolution = anyWhereSetObj.resolution && anyWhereSetObj.resolution.toLowerCase() || this.resolution.toLowerCase();
      // 分辨率/码率 初始化 新key 只兼容mac 初始化
      if (anyWhereSetObj.resolutionList || anyWhereSetObj.fpsList) {
        const parsedResList = JSON.parse(anyWhereSetObj.resolutionList);
        // 生成分辨率列表（去重处理）
        this.resolutionList = [...new Set(parsedResList.map(item => item.resolution))].map(res => ({
          label: res
        }));
        // 查找匹配的分辨率配置
        const matchedResolution = parsedResList.find(item => item.resolution.toLowerCase() === this.resolution);
        // 生成对应的帧率列表
        this.fpsList = matchedResolution ? matchedResolution.fps.map(f => ({
          label: f
        })) : [];
      } else {
        this.resolutionOptions = anyWhereSetObj.resolutionOptions && anyWhereSetObj.resolutionOptions.split(',').map(resolutionValue => ({
          label: `${resolutionValue}p`
        })) || this.resolutionOptions;
        if (this.resolutionOptions.some(obj => obj.label === '1080p')) {
          // 在1080P对象之后插入1080i新的对象
          const index1080P = this.resolutionOptions.findIndex(obj => obj.label === '1080p');
          this.resolutionOptions.splice(index1080P + 1, 0, {
            label: '1080i'
          });
        }
        this.fpsOptions = anyWhereSetObj.fpsOptions && anyWhereSetObj.fpsOptions.split(',').map(fpsValue => ({
          label: fpsValue
        })) || this.fpsOptions;
      }
      // 缩放的值
      this.inputZoom = this.zoom = anyWhereSetObj.zoom && Number(anyWhereSetObj.zoom) || this.inputZoom || this.zoom;
      // tvua操作时，更新数组presetPositions中zoom的值
      if (this.presetPositions.length != 0 && this.activeType) {
        // 预设的缩放值(操作预设的圆盘同步对应对应zoom)
        this.presetPositions[this.activeType == 'first' ? 0 : 1].zoom = this.presetPositions[this.activeType == 'first' ? 0 : 1].inputZoom = this.inputZoom;
      }
      // 初始化温度和色调滑块的值
      this.inputTemperature = this.temperature = anyWhereSetObj.whiteBalance && Number(anyWhereSetObj.whiteBalance.temp) || this.inputTemperature || this.temperature;
      this.inputTints = this.tints = anyWhereSetObj.whiteBalance && Number(anyWhereSetObj.whiteBalance.tint) || this.inputTints || this.tints;
      // mic 初始化
      this.micOptions = anyWhereSetObj !== null && anyWhereSetObj !== void 0 && anyWhereSetObj.audioDeviceList ? JSON.parse(anyWhereSetObj.audioDeviceList) : this.micOptions || [];
      this.$nextTick(() => {
        this.micPosition = anyWhereSetObj.audioDeviceID || '';
      });
      // camera 初始化 新key 只兼容mac
      if (anyWhereSetObj.videoDeviceID || anyWhereSetObj.videoDeviceList) {
        this.cameraOptions = anyWhereSetObj !== null && anyWhereSetObj !== void 0 && anyWhereSetObj.videoDeviceList ? JSON.parse(anyWhereSetObj.videoDeviceList) : this.cameraOptions || [];
        this.$nextTick(() => {
          this.cameraPosition = anyWhereSetObj.videoDeviceID && anyWhereSetObj.videoDeviceID;
        });
      } else {
        // cameraOptions 初始化
        this.cameraOptions = (typeof (anyWhereSetObj === null || anyWhereSetObj === void 0 ? void 0 : anyWhereSetObj.cameraOptions) === 'string' ? anyWhereSetObj.cameraOptions.split(',') : []).map(optionValue => ({
          value: optionValue,
          label: this.State.cameraOptionsMapping[optionValue] || 'Unknown'
        })) || this.cameraOptions;
        this.$nextTick(() => {
          this.cameraPosition = anyWhereSetObj.cameraPosition && anyWhereSetObj.cameraPosition || this.cameraPosition;
        });
      }

      // 初始化白平衡自动
      this.whiteBalanceOptions = anyWhereSetObj.whiteBalancePredefined && JSON.parse(anyWhereSetObj.whiteBalancePredefined || this.whiteBalanceOptions).map(item => {
        var _label$charAt;
        // 获取预定义白平衡的键（如daylight）和值（如{temp: 5200, tint: 0}）
        const label = Object.keys(item)[0]; // 获取对象的键，作为标签
        const {
          temp,
          tint
        } = item[label]; // 解构赋值获取温度和色调
        return {
          label: ((_label$charAt = label.charAt(0)) === null || _label$charAt === void 0 ? void 0 : _label$charAt.toUpperCase()) + label.slice(1),
          // 大写首字母
          temp: `${temp}`,
          tint: `${tint}`
        };
      });
      // 如果是安卓机型则不添加Manual(不支持手动)
      if (this.platForm != '11') {
        this.whiteBalanceOptions && this.whiteBalanceOptions.splice(1, 0, {
          label: 'Manual'
        });
      }
      this.whiteBalanceAuto = anyWhereSetObj.whiteBalanceAuto && anyWhereSetObj.whiteBalanceAuto || this.whiteBalanceAuto;
      // 初始化获取下拉框场景的选项
      this.updateSelectBySliders();
      // 默认视图
      this.defaultView = anyWhereSetObj.defaultView && anyWhereSetObj.defaultView || this.defaultView;
      // 是否支持云台功能
      this.isSupportGimbal = anyWhereSetObj.isSupportGimbal && anyWhereSetObj.isSupportGimbal || this.isSupportGimbal;
      this.changeSpeakerSwitch = false;
    },
    getIconClass(label) {
      const iconMapping = {
        Daylight: 'iconfont icon-daylight',
        Shade: 'iconfont icon-shade',
        Cloudy: 'iconfont icon-cloudy',
        Tungsten: 'iconfont icon-tungsten',
        Fluorescent: 'iconfont icon-fluorescent',
        Flash: 'iconfont icon-flash',
        Manual: 'iconfont icon-manual'
      };
      return iconMapping[label] || 'iconfont icon-daylight';
    },
    // 更新温度和色调滑块的值
    changeWhiteBalanceAuto(value) {
      if (value !== 'Manual') {
        const selectedOption = this.whiteBalanceOptions.find(option => option.label === value);
        if (selectedOption) {
          // 更新温度和色调滑块的值
          this.temperature = Number(selectedOption.temp);
          this.tints = Number(selectedOption.tint);
          this.inputTemperature = Number(selectedOption.temp); // 同步更新输入值
          this.inputTints = Number(selectedOption.tint);
        }
        this.changeProperty('whiteBalance');
      } else {
        // 手动
        this.whiteBalanceAuto = 0;
        this.changeProperty('whiteBalanceAuto');
      }
    },
    // 更新场景下拉选项
    updateSelectBySliders() {
      // 初始化一个变量来记录找到的匹配项的标签
      let matchedLabel = null;

      // 遍历所有白平衡选项
      this.whiteBalanceOptions && this.whiteBalanceOptions.forEach(option => {
        // 检查当前选项的温度和色调是否与滑块的值完全相等
        if (this.temperature == option.temp && this.tints == option.tint) {
          matchedLabel = option.label; // 如果找到匹配项，记录其标签
        }
      });

      // 如果找到匹配项，更新 select 绑定值
      if (matchedLabel !== null) {
        this.whiteBalanceType = matchedLabel;
      } else {
        this.whiteBalanceType = 'Manual';
      }
    },
    deBounceChangeProperty(type, value) {
      this.lastParams = {
        type,
        value
      };
      // 清理现有的防抖定时器
      clearTimeout(this.debounceTimer);
      // 设置新的防抖定时器
      this.debounceTimer = setTimeout(() => {
        this.changeProperty(this.lastParams.type, this.lastParams.value);
      }, 500);
    },
    changeProperty(type, value, noMessage) {
      this.params = {
        partyCode: Number(this.partyCode),
        rtilCode: this.singChannel.id,
        peerId: this.peerId,
        setting: {
          key: type
        }
      };
      if (type == 'resolutionFps' || type == 'macResolution' || type == 'macFps') {
        var _this$resolution;
        // 如果选择的是1080i且fps为25或30,则将fps设置为50
        if (type == 'resolutionFps' && value == '1080i' && (this.fps == '25' || this.fps == '30')) {
          this.fps = '50';
        }
        if (type == 'macResolution') {
          this.handleResolutionChange(this.resolution);
        }
        // 兼容Mac
        this.params.setting = {
          key: 'resolutionFps',
          value: JSON.stringify({
            height: type != 'resolutionFps' ? this.resolution : Number((_this$resolution = this.resolution) === null || _this$resolution === void 0 ? void 0 : _this$resolution.replace(/(p|i)$/, '')),
            fps: type != 'resolutionFps' ? this.fps : Number(this.fps),
            interlace: this.resolution == '1080i' ? 1 : 0
          })
        };
      } else if (type == 'switchCamera') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            position: this.cameraPosition
          })
        };
      } else if (type == 'lockScreen') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            lock: this.locked
          })
        };
      } else if (type == 'speakerStatus') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            status: Number(this.speakerStatus)
          })
        };
      } else if (type == 'autoFocus') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            auto: this.autoFocus
          })
        };
      } else if (type == 'autoExposure') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            auto: this.autoExposure
          })
        };
      } else if (type == 'whiteBalanceAuto') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            auto: this.whiteBalanceAuto
          })
        };
      } else if (type == 'whiteBalance') {
        this.updateSelectBySliders();
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            temp: Number(this.inputTemperature),
            tint: Number(this.inputTints)
          })
        };
      } else if (type == 'focusDistance') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            distance: Number(this.inputFocus)
          })
        };
      } else if (type == 'exposure') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            exposure: Number(this.inputExposure)
          })
        };
      } else if (type == 'zoom') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            zoom: value || Number(this.inputZoom)
          })
        };
      } else if (type == 'defaultView') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            display: this.defaultView
          })
        };
      } else if (type == 'longPressGimbal') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            direction: this.direction,
            event: this.longPressGimbalEvent
          })
        };
      } else if (type == 'singleClickGimbal') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            direction: this.direction
          })
        };
      } else if (type == 'resetGimbal') {
        this.params.setting = {
          key: type,
          value: null
        };
      } else if (type == 'speakerVolume') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            volume: value || Number(this.inputVolume)
          })
        };
      } else if (type == 'switchAudioSource') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            deviceID: this.micPosition
          })
        };
      } else if (type == 'switchVideoSource') {
        this.params.setting = {
          key: type,
          value: JSON.stringify({
            deviceID: this.cameraPosition
          })
        };
      }
      this.axios.post('/partyline-backend/anywhere/setting', this.params).then(res => {
        if (res.data.errorCode != '0x0') {
          if (type != 'resetGimbal' && type != 'longPressGimbal' && type != 'singleClickGimbal') {
            this.$message({
              type: 'error',
              message: res.data.errorMessage
            });
          } else {
            this.showOperationPrompt('failure');
          }
          if (type == 'resetGimbal') {
            this.isCenterPressed = false;
          }
        } else {
          // 由于安卓机型不支持手动调节并不显示场景对应的值，
          // 所以需要当关闭自动白平衡时再次设置一次白平衡值（temp和tint）
          if (this.whiteBalanceAuto == 0 && this.platForm == '11' && type == 'whiteBalanceAuto') {
            this.changeProperty('whiteBalance');
            return;
          }
          if (type == 'resetGimbal') {
            this.isCenterPressed = false;
          }
          if (type != 'resetGimbal' && type != 'longPressGimbal' && type != 'singleClickGimbal' && !noMessage) {
            this.$message({
              type: 'success',
              message: this.$t('commonFunction.operateSuccessful')
            });
          } else {
            this.showOperationPrompt('success');
          }
        }
      });
    },
    resetGimBal() {
      this.clickGimbal = true;
      this.isCenterPressed = true;
      this.changeProperty('resetGimbal');
    },
    handleMousedown(e) {
      this.clickGimbal = true;
      this.direction = e;
      if (this.direction == 0) {
        this.isTopPressed = true;
      } else if (this.direction == 1) {
        this.isBottomPressed = true;
      } else if (this.direction == 2) {
        this.isLeftPressed = true;
      } else if (this.direction == 3) {
        this.isRightPressed = true;
      }
      // 启动按下定时器
      this.pressTimer = setTimeout(() => {
        this.isLongPress = true; // 设置长按标志
        this.longPressGimbalEvent = 1; // 开始长按
        this.sendLongPressGimbalCommand(); // 开始发送长按命令
      }, 300); // 0.3秒长按
    },

    handleMouseup() {
      clearTimeout(this.pressTimer); // 清除按下定时器
      // 如果是长按，不执行单击
      if (this.isLongPress) {
        this.longPressGimbalEvent = 0;
        this.changeProperty('longPressGimbal'); // 结束长按
        this.isTopPressed = false;
        this.isBottomPressed = false;
        this.isLeftPressed = false;
        this.isRightPressed = false;
      } else {
        this.singleClickGimbal(); // 调用单击函数
      }

      this.isLongPress = false; // 重置长按标志
    },

    sendLongPressGimbalCommand() {
      this.changeProperty('longPressGimbal');
    },
    handleMouseLeave() {
      clearTimeout(this.pressTimer);
      if (this.isLongPress) {
        this.longPressGimbalEvent = 0; // 重置长按事件
        this.changeProperty('longPressGimbal'); // 结束长按
        this.isTopPressed = false;
        this.isBottomPressed = false;
        this.isLeftPressed = false;
        this.isRightPressed = false;
      }
      this.isLongPress = false; // 重置长按标志
    },

    singleClickGimbal() {
      this.changeProperty('singleClickGimbal');
      this.isTopPressed = false;
      this.isBottomPressed = false;
      this.isLeftPressed = false;
      this.isRightPressed = false;
    },
    changeInputValue(value, property) {
      let newValue = Number(value);
      // 定义一个对象，映射属性到它们各自的范围键和更改函数
      const propertySettings = {
        tint: {
          rangeKey: 'whiteBalanceRange',
          changeFunction: 'whiteBalance',
          property: 'inputTints'
        },
        exposure: {
          rangeKey: 'exposureRange',
          changeFunction: 'exposure',
          property: 'inputExposure'
        },
        focus: {
          rangeKey: 'focusDistanceRange',
          changeFunction: 'focusDistance',
          property: 'inputFocus'
        },
        temperature: {
          rangeKey: 'whiteBalanceRange',
          changeFunction: 'whiteBalance',
          property: 'inputTemperature'
        }
      };

      // 获取当前属性的设置
      const settings = propertySettings[property];
      // 解析指定范围
      const parsedRange = JSON.parse(this.anyWhereSetObj[settings.rangeKey]);
      // 确定最大值和最小值的键
      const maxKey = property === 'temperature' ? 'tempMax' : `${property}Max`;
      const minKey = property === 'temperature' ? 'tempMin' : `${property}Min`;
      // 根据范围调整值
      if (newValue > Number(parsedRange[maxKey])) {
        newValue = Number(parsedRange[maxKey]);
      } else if (newValue < Number(parsedRange[minKey])) {
        newValue = Number(parsedRange[minKey]);
      }

      // 更新相应的属性和状态
      if (property == 'tint') property = 'tints';
      this[settings.property] = this[property] = newValue;
      // 调用更改属性的方法
      this.deBounceChangeProperty(settings.changeFunction);
    },
    // speaker开关
    changeSpeakerStatus(value, type) {
      this.changeSpeakerSwitch = true;
      if (value == 0) {
        this.speakerStatus = 0;
        this.inputVolume = this.speakerVolume = 0;
      } else {
        this.speakerStatus = 1;
      }
      this.changeProperty(type, this.speakerStatus);
    },
    // 音量
    changeSpeakerVolumeInputValue(value, isreset) {
      if (!this.anyWhereSetObj.speakerVolume) return;
      let speakerValue = Number(value);
      if (speakerValue > 100) {
        speakerValue = 100;
      } else if (speakerValue < 0) {
        speakerValue = 0;
      }
      this.inputVolume = this.speakerVolume = speakerValue;
      if (this.inputVolume == 0 || this.speakerVolume == 0) {
        this.speakerStatus = 0;
      } else {
        this.speakerStatus = 1;
      }
      if (isreset) {
        this.deBounceChangeProperty('speakerVolume', 100);
      } else {
        // 滑动到0的时候不下发音量（为了记录滑动前的音量值当用户后续unmute时去恢复）
        if (this.inputVolume != 0) {
          this.deBounceChangeProperty('speakerVolume');
        }
      }
      this.changeProperty('speakerStatus', this.speakerStatus, true);
    },
    async changePresetZoomInputValue(value, isreset) {
      if (!this.anyWhereSetObj.zoom || !this.anyWhereSetObj.zoomRange) return;
      let zoomValue = Number(value);
      if (zoomValue > Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMax)) {
        zoomValue = Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMax);
      } else if (zoomValue < Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMin)) {
        zoomValue = Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMin);
      }
      // 预设的缩放值(操作预设的圆盘同步对应对应zoom)
      this.presetPositions[this.activeType == 'first' ? 0 : 1].zoom = this.presetPositions[this.activeType == 'first' ? 0 : 1].inputZoom = zoomValue;
      // 调节zoom直接更新预设这一组值
      await this.saveDegree(true, true);
      if (isreset) {
        this.deBounceChangeProperty('zoom', 1);
      } else {
        this.deBounceChangeProperty('zoom', zoomValue);
      }
    },
    changeZoomInputValue(value, isreset) {
      if (!this.anyWhereSetObj.zoom || !this.anyWhereSetObj.zoomRange) return;
      let zoomValue = Number(value);
      if (zoomValue > Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMax)) {
        zoomValue = Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMax);
      } else if (zoomValue < Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMin)) {
        zoomValue = Number(JSON.parse(this.anyWhereSetObj.zoomRange).zoomMin);
      }
      this.inputZoom = this.zoom = zoomValue;
      if (isreset) {
        this.deBounceChangeProperty('zoom', 1);
      } else {
        this.deBounceChangeProperty('zoom');
      }
    },
    closeDialog() {
      this.info.show = false;
      this.$emit('closeAnywherePreview');
    }
  }
};